import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerSummaryStatsModel
} from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerSummaryStatsModel";

export class ProSkillManagerCandidateSummaryModel extends Model {
  constructor(
    public total: number = 0,
    public preStart: number = 0,
    public inProgress: number = 0,
    public completed: number = 0,
    public stats: ProSkillManagerSummaryStatsModel = new ProSkillManagerSummaryStatsModel()
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerCandidateSummaryModel>): ProSkillManagerCandidateSummaryModel {
    return createModel<ProSkillManagerCandidateSummaryModel>(ProSkillManagerCandidateSummaryModel, {
      ...model
    });
  }
}
